import { useCallback, useMemo } from "react";
import useAuthStore from "./states/authStore";
import aftrPrtyLogoSmall from "./assets/aftrprtyfavicon.png"
import aftrPrtyLogo from "./assets/aftrprtylogo.png"
import StoreLogo from "./assets/icons/Store_logo.svg";
import "./styles/Main.css";
import { NavBar, Page, PageHeader, NavBarMobile } from "@iq/models";
import { GoHome } from "react-icons/go";
import AppUserMenu from "./components/AppUserMenu";
import useIsSmallScreen from "./hooks/useIsSmallScreen";
import { logout } from "./services/authApi";

const STORE_URL =
    process.env.REACT_APP_STORE_URL ||
    (process.env.NODE_ENV === "development"
        ? "http://localhost:3008"
        : "https://striver.aftrprty.shop/store");

// import HeaderClockAction from "./components/HeaderClockAction";

function Main(){

    const profile = useAuthStore((state) => state.profile);
    const clearAuth = useAuthStore((state) => state.clearAuth);
    const isSmallScreen = useIsSmallScreen();

    const profileName = profile?.name ?? "User";
    const profileId = profile?.id ?? null;

    const handleLogout = useCallback(async () => {
        try {
            await logout();
        } catch {
            // Clear client auth state even if the logout request fails.
        } finally {
            clearAuth();
            window.location.assign("/login-client");
        }
    }, [clearAuth]);

    const appLinks = useMemo(() => ([
        // { label: "CRM", image: CRMLogo, href: "/contacts", variant: "crm" },
        // { label: "Tickets", image: TicketsLogo, href: "/IT", variant: "tickets" },
        // { label: "Admin", image: AdminLogo, href: "/admin", variant: "admin" },
        // { label: "Projects", image: AdminLogo, href: "/projects", variant: "projects" },
        // { label: "Payment", image: AdminLogo, href: "/payment", variant: "payment" },
        { label: "Store", image: StoreLogo, href: STORE_URL, variant: "store" },
    ]), []);

    const mobileNavLinks = useMemo(() => ([
        { label: "Home", value: "Home", icon: <GoHome size={20} /> },
        { label: "Store", value: "Store", icon: <img src={StoreLogo} alt="" style={{ height: "1.25rem" }} /> },
    ]), []);

    const handleMobileNavChange = useCallback((value) => {
        if (value === "Store") {
            window.location.assign(STORE_URL);
        }
    }, []);

    return(
            <div className="crm-layout app">
                <div className="nav-section">
                    {!isSmallScreen && (
                        <NavBar
                            activePage="Home"
                            navItems={[]}
                            onPageChange={() => {}}
                            footerAction={{
                                label: "Home",
                                icon: <GoHome size={24} />,
                                active: true,
                                onClick: () => {},
                            }}
                    />)}
                </div>
                <PageHeader
                    title={<img src={aftrPrtyLogo} alt="AftrPrty Logo" style={{ height: "1.25rem"}} />}
                    userMenu={isSmallScreen ? (
                        <NavBarMobile
                            activePage="Home"
                            navItems={mobileNavLinks}
                            onPageChange={handleMobileNavChange}
                            logoutAction={{ onClick: handleLogout }}
                            user={{ name: profileName }}
                        />
                    ) : (
                        <AppUserMenu name={profileName} id={profileId} />
                    )}
                />
                <Page>
                    <div className="app-main-content">
                        <div className="main-panel-title-container">
                            <h2 className="main-panel-welcome">Welcome back,</h2>
                            <h2 className="main-panel-profile-name">{profileName}</h2>
                        </div>
                        <h2 className="main-panel-title">- Your Apps -</h2>
                        <div className="main-panel-grid">
                            {appLinks.map((app) => (
                                <div className="main-panel-grid-item">
                                    <a
                                        key={app.label}
                                        href={app.href}
                                        className={`main-app-link main-app-link--${app.variant}`}
                                    >
                                        <img src={app.image} alt={app.label} className="main-app-link-image"/>
                                        <p className="main-app-link-text">{app.label}</p>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="main-panel-spacer" aria-hidden="true" />
                </Page>
            </div>
    )
}

export default Main